import { useEffect, useState, useContext } from "react"
import intl from "react-intl-universal"
import { getControlExpiring } from "../../../../../services/ciq"
import { Table } from "../../../../molecules/Table"

import styles from "./index.module.scss"
import useDataApi from "../../../../../hooks/useDataApi"
import AuthContext from "../../../../../contexts/Auth"
import InfiniteScroll from "../../../../atoms/InfiniteScroll"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import { toast } from "@stardust-ds/react"

export const ControlExpiring = () => {
  const [oControlExpiriginRes, fnControlExpiringReq] = useDataApi(getControlExpiring)
  const { oUser } = useContext(AuthContext)

  const [aControlExpiring, fnSetAControlExpiring] = useState([])
  const [oParams, fnSetOParams] = useState({ nPage: 1 })

  async function fnGetControlExpiringWithParams() {
    if (oControlExpiriginRes?.loading) return

    if (oParams.nPage === 1) fnSetAControlExpiring([])

    const cParams = `page=${oParams.nPage}`
    const response = await fnControlExpiringReq(cParams)
    fnSetAControlExpiring((prev) => [...prev, ...(response?.data?.data || [])])
  }

  useEffect(() => {
    ;(async () => {
      await fnGetControlExpiringWithParams()
    })()
  }, [oParams])

  useEffect(() => {
    if (!oControlExpiriginRes.done || !oControlExpiriginRes.error) return

    toast({
      type: "error",
      title: intl.get("ciq.control_expiring_list.error.title"),
      description: intl.get("ciq.control_expiring_list.error.description"),
    })
  }, [oControlExpiriginRes])

  function fnNextPage(nPage) {
    fnSetOParams((prev) => ({ ...prev, nPage }))
  }

  const transformDate = (date) => {
    const cUserTimeZone = oUser?.data?.user_ctimezone
    const [data] = fnFormatDateFromUTC(
      `${date} 12:00`,
      "DD/MM/YYYY - HH:mm",
      cUserTimeZone,
    ).split(" - ")

    return data
  }

  const aTableBody =
    aControlExpiring?.map((item) => ({
      control_cname: item?.control_cname,
      control_cbatch: item?.control_cbatch,
      control_dactivation: transformDate(item?.control_dactivation),
      control_dexpiration: (
        <span className={styles.expirationDate} style={item?.control_vstatus === 1 ? { color: "#FF3541" } : {}}>
          {transformDate(item?.control_dexpiration)}
        </span>
      ),
      type: item?.analyte_types?.join(", ") || "",
      control_elevel: item?.control_elevel,
    })) || []

  return (
    <div className={styles.wrapperControlExpiring}>
      <h2>{intl.get("ciq.control_expiring_list.title")}</h2>
      <div id="control-expiring-list">
        <InfiniteScroll
          fnNext={fnNextPage}
          nTotalPages={oControlExpiriginRes?.data?.data?.last_page}
          nDataLength={aControlExpiring.length}
          bStopPagination={oControlExpiriginRes?.error || oControlExpiriginRes?.loading}
          scrollableTarget="control-expiring-list"
        >
          <Table
            bEdit={false}
            cursorNormal
            thead={[
              intl.get("ciq.control_expiring_list.table.name"),
              intl.get("ciq.control_expiring_list.table.batch"),
              intl.get("ciq.control_expiring_list.table.activation"),
              intl.get("ciq.control_expiring_list.table.expiration"),
              intl.get("ciq.control_expiring_list.table.analyte_type"),
              intl.get("ciq.control_expiring_list.table.level"),
            ]}
            tbodyArray={aTableBody}
            load={oControlExpiriginRes?.loading}
            loadingInnerTable={oControlExpiriginRes?.loading}
          />
        </InfiniteScroll>
      </div>
    </div>
  )
}
